import React from "react";
import { useTranslation } from "react-i18next";

export default function ChatHeader({
  sideMenuVisible,
  toggleSideMenu,
  assistantName,
  exploring,
  currentLang = "en",
  onLangChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <header
      className="chat-header"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ display: "flex", alignItems: "center" }}>
        <button
          onClick={toggleSideMenu}
          className="toggle-side-menu-button"
          style={{ marginRight: 12 }}
          aria-label={sideMenuVisible ? t("hide_menu", "Hide menu") : t("show_menu", "Show menu")}
        >
          {sideMenuVisible ? "☰" : "➤"}
        </button>
        {!exploring && <h1 style={{ margin: 0 }}>{assistantName}</h1>}
      </div>
      <div className="lang-switcher" style={{ minWidth: 120 }}>
        <select
          id="lang-select"
          value={currentLang}
          onChange={e => onLangChange(e.target.value)}
          style={{
            padding: "4px 10px",
            borderRadius: 6,
            margin: "10px",
            border: "1px solid #bcbcbc",
            background: "#f6f6f6",
            fontWeight: 500,
            fontSize: "1em",
          }}
          aria-label={t("select_language", "Select language")}
        >
          <option value="en">🇬🇧</option>
          <option value="es">🇪🇸</option>
          <option value="it">🇮🇹</option>
          <option value="fr">🇫🇷</option>
        </select>
      </div>
    </header>
  );
}